module.exports = __webpack_public_path__ + "static/media/amazon.e6b00f87.svg";